module.exports = __webpack_public_path__ + "assets/pin.58838460.svg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/svgs/pin.svg
// module id = 1461
// module chunks = 6 8